import React from 'react'

const UsersAppointment = () => {
  return (
    <div>UsersAppointment</div>
  )
}

export default UsersAppointment